export enum HeaderType {
  GROUP = 'GROUP',
  PROFILE = 'PROFILE',
  PROPOSAL = 'PROPOSAL',
  PAGE = 'PAGE',
}
